import { render, staticRenderFns } from "./PL_Benefit.vue?vue&type=template&id=6ff9d43e&"
import script from "./PL_Benefit.vue?vue&type=script&lang=js&"
export * from "./PL_Benefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports